import React, { useEffect, useState } from 'react';
import { useNavigate }               from 'react-router-dom';
import { useAuth }                   from '../contexts/AuthContext';
import { getVehicles }               from '../api/vehicles';
import './MyProjectsPage.css';

export default function MyProjectsPage() {
  const { user, signOut }       = useAuth();
  const navigate                = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    getVehicles()
      .then(res => setVehicles(res.success ? res.data : []))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  function handleSignOut() { signOut(); navigate('/'); }

  function selectProject(vehicle) {
    // Store active vehicle so Dashboard can pick it up
    localStorage.setItem('ar_active_vehicle', JSON.stringify(vehicle));
    navigate('/dashboard');
  }

  function handleEdit(e, vehicle) {
    e.stopPropagation();
    navigate(`/projects/${vehicle.vehicleId}/edit`);
  }

  const vehicleLabel = v =>
    `${v.year} ${v.make} ${v.model}${v.trim_package ? ' ' + v.trim_package : ''}`.trim();

  return (
    <div className="mp-root">

      {/* ── Top bar ─────────────────────────────────────────────── */}
      <header className="mp-header">
        <div className="mp-header-brand">
          <span className="mp-header-gear">⚙</span>
          <span className="mp-header-name">AutoRestoration</span>
        </div>
        <div className="mp-header-user">
          <span className="mp-username">@{user?.username}</span>
          <button className="mp-signout-btn" onClick={handleSignOut}>Sign Out</button>
        </div>
      </header>

      <div className="mp-body">

        {/* ── Page heading ────────────────────────────────────────── */}
        <div className="mp-page-header">
          <h1 className="mp-page-title">My Projects</h1>
          <button className="mp-add-btn" onClick={() => navigate('/projects/add')}>
            <span>＋</span> Add Project Car
          </button>
        </div>

        {/* ── Content ─────────────────────────────────────────────── */}
        {loading ? (
          <div className="mp-loading">Loading projects…</div>

        ) : vehicles.length === 0 ? (
          <div className="mp-empty">
            <div className="mp-empty-icon">🔧</div>
            <h2 className="mp-empty-heading">No Project Cars Yet</h2>
            <p className="mp-empty-text">
              You haven't added a project car yet. Click the button below to get started
              on your first classic car restoration.
            </p>
            <button className="mp-add-btn large" onClick={() => navigate('/projects/add')}>
              <span>＋</span> Add Your First Project Car
            </button>
          </div>

        ) : (
          <div className="mp-grid">
            {vehicles.map(v => (
              <div
                key={v.vehicleId}
                className="mp-card"
                onClick={() => selectProject(v)}
                title="Click to open this project"
              >
                {/* Edit wrench — top-right */}
                <button
                  className="mp-edit-btn"
                  onClick={e => handleEdit(e, v)}
                  title="Edit Project"
                >
                  🔧
                  <span className="mp-edit-label">Edit Project</span>
                </button>

                {/* Primary badge */}
                {v.is_primary === 1 && (
                  <span className="mp-primary-badge">Active</span>
                )}

                <div className="mp-card-icon">🚗</div>

                <h3 className="mp-card-title">{vehicleLabel(v)}</h3>

                {v.nickname && (
                  <p className="mp-card-nick">"{v.nickname}"</p>
                )}

                <div className="mp-card-meta">
                  {v.engine_desc && (
                    <span className="mp-card-meta-item">🔧 {v.engine_desc}</span>
                  )}
                  {v.transmission_desc && (
                    <span className="mp-card-meta-item">⚙ {v.transmission_desc}</span>
                  )}
                  {v.vin && (
                    <span className="mp-card-meta-item">VIN: {v.vin}</span>
                  )}
                </div>

                <div className="mp-card-footer">
                  Tap to open project →
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
